import {DatePipe} from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserUpdateRequest} from 'src/app/model/updateUserRequest';
import {UserData} from 'src/app/model/user-data';
import {NotificationService} from 'src/app/service/notification.service';
import {UserService} from 'src/app/service/user.service';
import {PortalRolesRequest} from 'src/app/model/portal';
import {User} from 'src/app/model/user';
import {LocalStorageService} from 'ngx-webstorage';
import {ClientService} from "../../service/client.service";
import {Client} from "../../model/client";

@Component({
  selector: 'app-edituser',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {

  userForm: FormGroup;
  portalRolesRequest = new PortalRolesRequest();
  userUpdateRequest: UserUpdateRequest;
  nursePractitionerFormEnabled: boolean = false;
  salesFormEnabled: boolean = false;
  clientsList: Client[];
  user: UserData;
  portals: Array<Object> =
    [
      {value: "SCHEDULER", name: "SCHEDULER"},
      {value: "PROVIDER", name: "PROVIDER"},
      {value: "CODER", name: "CODER"},
      {value: "IAM", name: "IDENTITY & ACCESS MANAGEMENT(IAM)"},
      {value: "SALES", name: "SALES"}
    ];
  displayRoles: any[] = [];
  allRoles: any[] = [];
  roles: any[] = [];
  role: string;
  minDate = new Date();
  maxDate = new Date();
  displayName: string;
  profile: User = new User;
  updatedBy: string;
  enableReset: boolean = false;

  fieldTextType: boolean;
  passModel: '';

  constructor(private formBuilder: FormBuilder,
              private userService: UserService,
              private _clientService: ClientService,
              private _notificationService: NotificationService,
              @Inject(MAT_DIALOG_DATA) public data: UserData,
              private datePipe: DatePipe,
              private _localStorage: LocalStorageService,
              public dialogRef: MatDialogRef<EditUserComponent>,) {
  }

  ngOnInit(): void {
    this.updatedBy = this._localStorage.retrieve('profile').displayName;
    console.log('check for ++++++' + this.updatedBy);

    console.log('PORTALS: ' + this.data.portals + ':: ROLES: ' + this.data.roles)
    this.userForm = this.formBuilder.group({
      userId: [this.data.userId],
      clientId: [this.data.clientId],
      employeeId: [this.data.employeeId],
      userName: [this.data.userName],
      firstName: [this.data.firstName, [Validators.required]],
      lastName: [this.data.lastName, [Validators.required]],
      email: [this.data.email, [Validators.required, Validators.email]],
      phoneNumber: [this.data.phoneNumber, [Validators.required]],
      dateOfBirth: [this.data.dateOfBirth],
      effectiveDate: [this.data.effectiveDate, [Validators.required]],
      terminationDate: [this.data.terminationDate, [Validators.required]],
      newPassword: [],

      timeZone: [this.data.timeZone + '', [Validators.required]],
      otpPreference: [this.data.otpPreference + '', [Validators.required]],
      npi: [this.data.npi],
      roles: new FormControl({value: this.data.roles, disabled: false}),
      portals: new FormControl({value: this.data.portals, disabled: false}),
      licensedState: [this.data.licensedState],
      licensedStartDate: [this.data.licensedStartDate],
      licensedExpiryDate: [this.data.licensedExpiryDate],
      serviceAddress1: [this.data.serviceAddress1],
      serviceAddress2: [this.data.serviceAddress2],
      serviceCity: [this.data.serviceCity],
      serviceState: [this.data.serviceState],
      serviceZip: [this.data.serviceZip],

      address1: [this.data.address1],
      address2: [this.data.address2],
      city: [this.data.city],
      state: [this.data.state],
      zip: [this.data.zip],
      updatedBy: [this.updatedBy],

      title: [this.data.title],

    })
    this.userService.getRoles()
      .subscribe(data => {
        if (!data) {
          return;
        }
        this.allRoles = data.roles;
        this.loadSelectedRoles();
      });
  }

  loadSelectedRoles() {
    this.portalRolesRequest.portals = this.data.portals;
    this.userService.getPortals(this.portalRolesRequest)
      .subscribe(data => {
        if (!data) {
          return;
        }
        if (data.successFlag) {
          let roleIds = []
          data.roles.filter(item => {
            this.allRoles.filter(role => {
              if (role.id == item) {
                this.displayRoles.push(role)
              }
            })
            this.data.roles.filter(role => {
              console.log(role + '==' + item);
              if (role == item) {
                roleIds.push(role)
              }
            })
          })
          this.userForm.get('roles').patchValue(roleIds)
        }
      }, error => console.log(error));
  }

  showNpForm(event: {
    isUserInput: any;
    source: { value: any; selected: any };
  }) {
    if (event.isUserInput) {
      if (event.source.selected === true) {
        if (event.source.value == 3) {
          this.nursePractitionerFormEnabled = true;
        }
        if (event.source.value == 11) {
          this.salesFormEnabled = true;
          this.loadClients();
        }
      } else {
        if (event.source.value == 3) {
          this.nursePractitionerFormEnabled = false;
        }
        if (event.source.value == 11) {
          this.salesFormEnabled = false;
        }
      }
    } else {
      if (event.source.value == 3) {
        this.nursePractitionerFormEnabled = true;
      }
      if (event.source.value == 11) {
        this.salesFormEnabled = true;
        this.loadClients();
      }
    }
  }

  updateUser(user: FormGroup) {
    this.userUpdateRequest = this.userForm.value;
    this.userUpdateRequest.effectiveDate = this.datePipe.transform(this.userForm.get('effectiveDate').value, "yyyy-MM-dd");
    this.userUpdateRequest.terminationDate = this.datePipe.transform(this.userForm.get('terminationDate').value, "yyyy-MM-dd");
    this.userUpdateRequest.licensedStartDate = this.datePipe.transform(this.userForm.get('licensedStartDate').value, "yyyy-MM-dd");
    this.userUpdateRequest.licensedExpiryDate = this.datePipe.transform(this.userForm.get('licensedExpiryDate').value, "yyyy-MM-dd");
    this.userUpdateRequest.updatedBy = this.updatedBy;
    this.userService.updateUser(this.userUpdateRequest)
      .subscribe(response => {
          if (!response) {
            return;
          }
          console.log(response);
          this.dialogRef.close(this.userForm.value);
          if (response.successFlag) {
            this._notificationService.success('User Changes added successfully');
          } else if (response.errorCode == 'EXISTING_USER_EXCEPTION') {
            this._notificationService.error(response.errorMsg);
          } else if (response.errorCode == 'MANDATORY_FIELD_EMPTY_EXCEPTION') {
            this._notificationService.error(response.errorMsg);
          } else {
            this._notificationService.error('User Changes not added');
          }
        },
        error => console.log(error));

  }

  deleteUnsupportedChars(event: any) {
    event.target.value = event.target.value.replace(/[^0-9]/g, "");
    event.target.dispatchEvent(new Event('input'));
  }

  keyPress2(event: any) {
    const pattern = /[a-z\ A-Z \ + \-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 5 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  getRolesByPortal({value}) {
    this.getRoles(value)
  }

  getRoles(portals: any[]) {
    this.portalRolesRequest.portals = portals;
    this.displayRoles = [];
    this.userService.getPortals(this.portalRolesRequest)
      .subscribe(data => {
        if (!data) {
          return;
        }
        console.log(data);
        if (data.successFlag) {
          data.roles.filter(item => {
            this.allRoles.filter(role => {
              if (role.id == item) {
                this.displayRoles.push(role)
              }
            })
          })
        }
      }, error => console.log(error));
  }

  rolesSelected(panelOpen: boolean) {
    if (!panelOpen) {
      this.enableReset = true;
    }
  }

  changeResetButton() {
    this.enableReset = false;
    this.userForm.get('portals').patchValue(this.data.portals);
    this.userForm.get('roles').patchValue(this.data.roles);
    this.getRoles(this.data.portals);
    this.data.roles.filter(role => {
      if (role === 3) {
        this.nursePractitionerFormEnabled = true;
      } else {
        this.nursePractitionerFormEnabled = false;
      }
      if (role === 11) {
        this.salesFormEnabled = true;
      } else {
        this.salesFormEnabled = false;
      }
    });
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  loadClients(): void {
    this._clientService.getClients()
      .subscribe(result => {
        if (!result) { return; }
        this.clientsList = result.clients;
      })
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

}
